import React from 'react';

const AnchorDetailsModal = ({ anchor, onClose }) => {
    if (!anchor) return null;

    const formatDate = (isoDateString) => {
        if (!isoDateString) return 'N/A';
        const date = new Date(isoDateString);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const renderLabelValue = (label, value) => (
        <div style={{ display: 'flex', marginBottom: '8px' }}>
            <span style={{ fontWeight: 600, color: '#555', minWidth: '140px' }}>{label}:</span>
            <span style={{ color: '#333' }}>{value || 'N/A'}</span>
        </div>
    );

    return (
        <div className="modal-backdrop show" style={{ overflow: 'hidden' }}>
            <div className="modal show" style={{ display: 'block', overflow: 'hidden', padding: '20px 0' }}>
                <div className="modal-dialog" style={{ 
                    maxWidth: '95%', 
                    width: '900px', 
                    height: 'calc(100vh - 40px)', 
                    margin: '0 auto', 
                    display: 'flex', 
                    flexDirection: 'column' 
                }}>
                    <div className="modal-content" style={{ 
                        borderRadius: '0', 
                        height: '100%', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        overflow: 'hidden' 
                    }}>
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '17px 30px', background: '#f7f9fa', flexShrink: 0 }}>
                            <h4 className="modal-title">
                                Anchor Company Details
                            </h4>
                            <button 
                                type="button" 
                                className="close" 
                                onClick={onClose}
                                style={{ fontSize: '28px', marginTop: '-33px' }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Modal Body - Scrollable */}
                        <div className="modal-body" style={{ flex: 1, overflow: 'auto', padding: '20px 30px' }}>
                            
                            {/* Company Information Section */}
                            <div style={{ marginBottom: '25px' }}>
                                <h5 style={{ 
                                    marginBottom: '15px', 
                                    fontWeight: '600', 
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    <i className="fa fa-info-circle" style={{ marginRight: '8px' }}></i>
                                    Company Information
                                </h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        {renderLabelValue('Company Name', anchor.companyName)}
                                        {renderLabelValue('GST Number', anchor.gstNumber)}
                                        {renderLabelValue('PAN Number', anchor.panNumber)}
                                        {renderLabelValue('Registration No.', anchor.registrationNumber)}
                                    </div>
                                    <div className="col-md-6">
                                        {renderLabelValue('Anchor ID', anchor.anchorId || anchor.id)}
                                        {renderLabelValue('Business Type', anchor.businessType)}
                                        {renderLabelValue('Buyer Company Type', anchor.buyerCompanyType)}
                                        {renderLabelValue('Nature of Business', anchor.natureOfBusiness)}
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '10px' }}>
                                    <div className="col-md-6">
                                        {renderLabelValue('Annual Turnover', anchor.annualTurnover)}
                                    </div>
                                    <div className="col-md-6">
                                        {renderLabelValue('Address', anchor.address)}
                                    </div>
                                </div>
                            </div>

                            {/* Contact Information Section */}
                            <div style={{ marginBottom: '25px' }}>
                                <h5 style={{ 
                                    marginBottom: '15px', 
                                    fontWeight: '600', 
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    <i className="fa fa-user" style={{ marginRight: '8px' }}></i>
                                    Contact Information
                                </h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        {renderLabelValue('Contact Person', anchor.contactName || anchor.contactPersonName)}
                                        {renderLabelValue('Mobile Number', anchor.contactMobile)}
                                    </div>
                                    <div className="col-md-6">
                                        {renderLabelValue('Designation', anchor.contactDesignation)}
                                        {renderLabelValue('Email', anchor.contactEmail)}
                                    </div>
                                </div>
                            </div>

                            {/* Verification Status Section */}
                            <div style={{ marginBottom: '25px' }}>
                                <h5 style={{ 
                                    marginBottom: '15px', 
                                    fontWeight: '600', 
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    <i className="fa fa-check-circle" style={{ marginRight: '8px' }}></i>
                                    Verification Status
                                </h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        {renderLabelValue('Status', anchor.verificationStatus || 'Pending')}
                                    </div>
                                    <div className="col-md-6">
                                        {renderLabelValue('Created At', formatDate(anchor.createdAt))}
                                    </div>
                                </div>
                                {anchor.remarks && (
                                    <div className="row" style={{ marginTop: '10px' }}>
                                        <div className="col-md-12">
                                            <div style={{ display: 'flex', marginBottom: '8px' }}>
                                                <span style={{ fontWeight: 600, color: '#555', minWidth: '140px' }}>Remarks:</span>
                                                <span style={{ color: '#333', whiteSpace: 'pre-wrap' }}>{anchor.remarks}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnchorDetailsModal;
